var render, staticRenderFns
import script from "./DragContainer.vue?vue&type=script&lang=js&"
export * from "./DragContainer.vue?vue&type=script&lang=js&"
import style0 from "./DragContainer.vue?vue&type=style&index=0&id=92c0d1f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c0d1f2",
  null
  
)

export default component.exports